import { createFrontendModule } from '@backstage/frontend-plugin-api'
import { SignInPageBlueprint } from '@backstage/plugin-app-react'
import { gitlabAuthApiRef, googleAuthApiRef } from '@backstage/core-plugin-api'

const gitlabProvider = {
  id: 'gitlab-auth-provider',
  title: 'GitLab',
  message: 'Sign in using DeepGaming GitLab',
  apiRef: gitlabAuthApiRef,
}

const googleProvider = {
  id: 'google-auth-provider',
  title: 'Google',
  message: 'Sign in with your DeepGaming Google account',
  apiRef: googleAuthApiRef,
}

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const { SignInPage } = await import('@backstage/core-components')
      // The guest backend provider refuses requests outside development anyway.
      const providers =
        process.env.NODE_ENV === 'development'
          ? (['guest', gitlabProvider, googleProvider] as const)
          : ([gitlabProvider, googleProvider] as const)
      return props => <SignInPage {...props} providers={[...providers]} />
    },
  },
})

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
})
